<div class="mb-2">
    <div class="filter-container">
        <span class="filter-title">Choose assets</span>
        <mat-form-field appearance="outline" class="search-field ms-3" >
            <input
                    matInput
                    placeholder="Search for assets"
                    [(ngModel)]="selectedFilter.searchTerm">
            <button color="primary" mat-icon-button matSuffix (click)="onFilterChange()">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>

        <button mat-stroked-button color="primary" class="ms-3" (click)="onUploadClick()">Upload portfolio details</button>
        <button [matMenuTriggerFor]="filtermenu" mat-flat-button color="primary" class="ms-3"><mat-icon>filter_list</mat-icon> Filters</button>
    </div>

    <mat-menu #filtermenu="matMenu" [overlapTrigger]="false" class="filter-menu">
        <div mat-menu-item [disabled]="true" [disableRipple]="true" (click)="$event.stopPropagation();">Default filters</div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.market == true" [(ngModel)]="visibilityList.market" (click)="$event.stopPropagation();" color="primary">Market</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.region == true" [(ngModel)]="visibilityList.region" (click)="$event.stopPropagation();" color="primary">Region</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.country == true" [(ngModel)]="visibilityList.country" (click)="$event.stopPropagation();" color="primary">Country</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.sector == true" [(ngModel)]="visibilityList.sector" (click)="$event.stopPropagation();" color="primary">Sector</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.industry == true" [(ngModel)]="visibilityList.industry" (click)="$event.stopPropagation();" color="primary">Industry</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.currency == true" [(ngModel)]="visibilityList.currency" (click)="$event.stopPropagation();" color="primary">Currency</mat-checkbox></div>

        <mat-divider class="w-100"></mat-divider>

        <div mat-menu-item [disabled]="true" [disableRipple]="true" (click)="$event.stopPropagation();">Fundamentals</div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.currentEPS == true" [(ngModel)]="visibilityList.currentEPS" (click)="$event.stopPropagation();" color="primary">Current EPS</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.priceToBook == true" [(ngModel)]="visibilityList.priceToBook" (click)="$event.stopPropagation();" color="primary">Price to book</mat-checkbox></div>

        <mat-divider class="w-100"></mat-divider>

        <div mat-menu-item [disabled]="true" [disableRipple]="true" (click)="$event.stopPropagation();">Technicals</div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.momentum == true" [(ngModel)]="visibilityList.momentum" (click)="$event.stopPropagation();" color="primary">Momentum</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.rsi == true" [(ngModel)]="visibilityList.rsi" (click)="$event.stopPropagation();" color="primary">RSI</mat-checkbox></div>

        <mat-divider class="w-100"></mat-divider>

        <div mat-menu-item [disabled]="true" [disableRipple]="true" (click)="$event.stopPropagation();">Management</div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.womenOnBoard == true" [(ngModel)]="visibilityList.womenOnBoard" (click)="$event.stopPropagation();" color="primary">% Women on board</mat-checkbox></div>
        <div mat-menu-item [disableRipple]="true"><mat-checkbox [checked]="visibilityList.peOwnership == true" [(ngModel)]="visibilityList.peOwnership" (click)="$event.stopPropagation();" color="primary">PE ownership</mat-checkbox></div>
    </mat-menu>


</div>
<div *ngIf="showAdvancedFilters" class="filter-container">
    <div class="row">
        <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>ESG Rating</mat-label>
                <input matInput disabled placeholder="ESG Rating">
            </mat-form-field>
        </div>
        <div class="col-md-2">
            <app-cim-datepicker label="Start date" [model]="selectedFilter.start_date" [isFullWidth]="true" (modelChanged)="selectedFilter.start_date = $event;"></app-cim-datepicker>
        </div>
        <!-- <div class="col-md-2">
           <app-cim-datepicker label="End date" [model]="selectedFilter.end_date" [isFullWidth]="true" (modelChanged)="selectedFilter.end_date = $event;"></app-cim-datepicker>
         </div>-->

    </div>
</div>

<div class="d-flex flex-row mt-2">
    <p class="mt-1 mb-0">Returned assets: {{meta && meta.total ? meta.total : 0}}</p>
    <button mat-button color="primary" class="ms-4" (click)="onFetchBtnClick()">Fetch companies</button>
</div>
